editHandoverItemController.$inject = ['$scope', '$uibModalInstance', '$translate', 'handoverItem'];
export function editHandoverItemController($scope, $uibModalInstance, $translate, handoverItem) {
  $scope.submit = submit;
  $scope.cancel = cancel;
  $scope.deleteHandoverItem = deleteHandoverItem;

  init();

  function submit() {
    $uibModalInstance.close({type: 'edit', data: $scope.handoverItem});
  }

  function cancel() {
    $uibModalInstance.dismiss('cancel');
  }

  function deleteHandoverItem() {
    $uibModalInstance.close({type: 'delete'});
  }

  function init() {
    $scope.handoverItem = handoverItem;
    $scope.isCustomCondition = handoverItem.handoverType === 'custom';
  }

}
